import { inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from '../services/auth.service';
import { AuthStorageService } from '../services/auth-storage.service';
import { isPasswordRecoveryPath } from '../utils/auth-route.utils';

export const guestGuard: CanActivateFn = async () => {
  const platformId = inject(PLATFORM_ID);
  if (!isPlatformBrowser(platformId)) {
    return true;
  }

  if (isPasswordRecoveryPath()) {
    return true;
  }

  const authService = inject(AuthService);
  const authStorage = inject(AuthStorageService);
  const router = inject(Router);

  await authService.bootstrap();

  if (!authStorage.isAuthenticated()) {
    return true;
  }

  const user = authStorage.currentUser();

  if (!user) {
    return true;
  }

  const role = user.role;

  switch (role) {

    case 'CLIENT':
      return router.createUrlTree([
        '/client/dashboard'
      ]);

    case 'TRADER':
      return router.createUrlTree([
        '/trader/dashboard'
      ]);

    default:
      return router.createUrlTree([
        '/'
      ]);

  }

};